export function UserOctagon({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.19092 2.46387C8.69579 2.17719 9.30925 2.18024 9.80225 2.46484L14.2515 5.03418H14.2524C14.6911 5.29198 14.9818 5.72997 15.0513 6.22559L15.0679 6.44141V11.5654C15.0677 12.1463 14.759 12.6777 14.2651 12.9629L9.81006 15.5352C9.30498 15.8225 8.69114 15.8199 8.19775 15.5352L3.74561 12.9648C3.24603 12.6704 2.94009 12.1358 2.93994 11.5654V6.43457C2.94007 5.92636 3.17608 5.456 3.56592 5.15527L3.74268 5.03711L8.19092 2.46387ZM8.99951 4.75488C7.6159 4.75512 6.50244 5.88095 6.50244 7.25293C6.5026 8.21071 7.03927 9.03997 7.82861 9.45898C6.96181 9.69951 6.21385 10.2031 5.74561 10.8984L5.74463 10.8994C5.07887 11.8909 5.7712 13.245 6.98975 13.2451H11.0103C12.2131 13.2449 12.9281 11.8869 12.2515 10.8945C11.7829 10.2011 11.0359 9.69896 10.1704 9.45898C10.9601 9.04008 11.4974 8.21098 11.4976 7.25293C11.4976 5.87122 10.3812 4.75488 8.99951 4.75488Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </svg>
    </span>
  );
}
